import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

const paymentService = {
  // Get all payment names
  getPaymentNames: async () => {
    try {
      const response = await axios.get(`${API_URL}/commonLOVs/lhpayments`, getAuthHeaders());
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || error.message };
    }
  },

  // Get payment details by payment ID
  getPaymentDetails: async (paymentId) => {
    try {
      const response = await axios.get(`${API_URL}/payments/byPaymentId/${paymentId}`, getAuthHeaders());
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || error.message };
    }
  },

  // Get payment lines by transaction ID and type
  getPaymentLinesByTransaction: async (typeTransactionId, paymentType) => {
    try {
      const response = await axios.get(
        `${API_URL}/payment-lines/byTypeTransactionId/${typeTransactionId}/${paymentType}`,
        getAuthHeaders()
      );
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || error.message };
    }
  },

  // Create payment line
  createPaymentLine: async (paymentLineData) => {
    try {
      const response = await axios.post(
        `${API_URL}/payment-lines`,
        paymentLineData,
        getAuthHeaders()
      );
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || error.message };
    }
  },

  // Delete payment line
  deletePaymentLine: async (lineId, paymentId, paymentAmount) => {
    try {
      const response = await axios.delete(
        `${API_URL}/payment-lines/${lineId}/${paymentId}/${paymentAmount}`,
        getAuthHeaders()
      );
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data||error || error.message };
    }
  }
};

export default paymentService;
